import { OnboardingStep } from "../services/onboardingService";

/**
 * Maps the last completed onboarding step to the next route the user
 * should land on when resuming the business onboarding flow.
 */
export const nextStepFor = (step: OnboardingStep | null): string => {
  switch (step) {
    case null:
    case "otp":
      return "/business/info";
    case "info":
      return "/business/services";
    case "services":
      return "/business/authorize";
    case "authorize":
      return "/business/slots";
    case "slots":
      return "/business/success";
    default: {
      // Exhaustiveness guard: forces a compile-time error if new steps are added.
      const _exhaustive: never = step;
      return _exhaustive;
    }
  }
};
